import PreviewReducer from "./Preview";
import CommonReducer from "./Common";

const reducers = {
  preview: PreviewReducer,
  common: CommonReducer
};

export default reducers;
